import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=3248cab6&"
import script from "./Reports.vue?vue&type=script&lang=js&"
export * from "./Reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3248cab6')) {
      api.createRecord('3248cab6', component.options)
    } else {
      api.reload('3248cab6', component.options)
    }
    module.hot.accept("./Reports.vue?vue&type=template&id=3248cab6&", function () {
      api.rerender('3248cab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/Reports.vue"
export default component.exports